import { connect } from 'react-redux'
import { formValueSelector, registerField } from 'redux-form'
import { selectors as DynamicFieldSelectors } from '../DynamicFields'
import { getFields, getSelects, getMasterChildOptions, getDynamicFields, getCityList } from './selectors'
import { FORM_NAME } from './constants'
import { getLookupsByType } from 'src/store/lookups'
import { LookupType } from 'shared'

const formSelector = formValueSelector(FORM_NAME)

export default connect(
  (state) => ({
    selects: getSelects(state),
    cities: getLookupsByType(state, LookupType.City),
    cityList: getCityList(state),
    dynamicFieldsDynamicOptions: DynamicFieldSelectors.getDynamicOptions(
      state,
      getDynamicFields(state),
      formSelector,
      'DynFieldData',
    ),
    dynamicOptions: getMasterChildOptions(state, formSelector, [
      {
        master: 'ORG_IndustryID',
        child: 'Subindustry',
      },
      {
        master: 'ORG_IndustrySubID',
        child: 'IndustrySubDetail',
      },

      {
        master: 'CityBusID',
        masterAlias: 'CityID',
        child: 'District',
      },

      {
        master: 'DistrictBusID',
        masterAlias: 'DistrictID',
        child: 'Zone',
      },
    ]),
  }),
  {
    registerFormField: (name) => registerField(FORM_NAME, name, 'Field'),
  },
)
